require('intersection-observer');
export default class LazyLoad {

  constructor() {

    $('.featured-content__image img').addClass('wpsmartcrop-image');
    $(document).on('load_lazy_image', '[data-src]',  function() {

      var target = this;
      var src = $(target).data('src');
      var newSrc = src,

      image = new Image();
      image.src = newSrc;

      $(target).addClass('lazy-loading');

      image.onload = function() {
        if( $(target)[0].tagName == 'IMG' ) {
          $(target).attr("src", src);
          $(target).trigger('wpsmartcrop-redraw');
          $(target).next('.wpsmartcrop-overlay').addClass('lazy-loaded');
        } else {
          $(target).css({
            'background-image' : 'url('+src+')',
          });
        }
        $(target).addClass('lazy-loaded');
      }
    });


    // Get all of the images that are marked up to animate load
    const animateEl = Array.prototype.slice.call(document.querySelectorAll('[data-src]'));

    const config = {
      // If the image gets within 50px in the Y axis, start the download.
      rootMargin: '1000px 0px',
      threshold: 0.01,
    };

    // The observer for the animateEl on the page
    let observer = new IntersectionObserver(onIntersection, config);

    if(animateEl.length) {
      for(var i=0; i < animateEl.length; i++) {
        observer.observe(animateEl[i]);
      }
    }

    function onIntersection(entries) {
      // Loop through the entries

      for(var i=0; i < entries.length; i++) {
        // Are we in viewport?
        if (entries[i].intersectionRatio > 0) {
          $(entries[i].target).trigger('load_lazy_image');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/lazy-load.js